import { createSelector } from "reselect";
import { initialState } from "./reducer";

const reducerState = (state) => state.OrderReview || initialState;

const makeOrderReviewSelectField = (field) =>
  createSelector(reducerState, (orderReviewState) => orderReviewState[field]);

export { reducerState, makeOrderReviewSelectField };
